<template>
    <el-dialog
      :title="!dataForm.id ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="viewData.visible">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="100px" class="org-dialog-form">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="组织名称" prop="name">
              <el-input v-model="dataForm.name" placeholder="组织名称"></el-input>
            </el-form-item>          
          </el-col>
          <el-col :span="12">
            <el-form-item label="组织代码" prop="code">
              <el-input v-model="dataForm.code" placeholder="组织代码" :disabled="viewData.forbidOrgTypeEdit"></el-input>
            </el-form-item>          
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="父节点名称" prop="parentName">
              <el-input 
                v-model="dataForm.parentName" 
                ref="parentname"
                :readonly="true"
                placeholder="父节点名称">
              </el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="租户" prop="tenantName">
              <el-input v-model="dataForm.tenantName" :readonly="true" placeholder="请选择租户" style="width: 100%">
              </el-input>
            </el-form-item>         
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="组织类型" prop="orgTypeChild">
              <el-select v-model="dataForm.orgTypeNew"   placeholder="请选择组织类型" style="width: 100%">
                <el-option v-for="item in orgTypeOptions" :key="item.value" :label="item.label" :value="item.value"> 
                </el-option>
              </el-select>
            </el-form-item>         
          </el-col>
        </el-row>
        <el-row v-if="false">
          <el-col :span="24" >
            <el-form-item label="路径" prop="path">
              <el-input v-model="dataForm.path" readonly placeholder="路径"></el-input>
            </el-form-item>  
          </el-col>
        </el-row>  
      </el-form>
      <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
          <el-button size="small" @click="viewData.visible = false">
            取消
          </el-button>
          <el-button size="small" type="primary" @click="dataFormSubmit()">
            确定
          </el-button>        
        </el-col>
      </el-row>
    </el-dialog>
  </template>
  
  <script>
    import {getOrgById, createOrg, editOrg} from '@/controller/sys';
    import { ORG_TYPE } from '@/utils/const';
    export default {
      data () {
        return {
          viewData: {
            visible: false,
            width:'',
            forbidOrgTypeEdit: false,
          },
          dataForm: {
            id: 0,
            name: '',
            code: '',
            parentId: '',
            parentName: '',
            parentNodePath: '',
            tenantId: '',
            tenantName: '',
            orgTypeNew: ''
          },
          orgType: '',   //父节点的组织类型
          dataRule: {
            name: [
              { required: true, message: '组织名称不能为空', trigger: 'blur' }
            ],
            code: [
              { required: true, message: '组织代码不能为空', trigger: 'blur' }
            ],
            tenantName: [
              { required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur' }
            ]
          },
          orgTypeOptions: ORG_TYPE,
        }
      },
      mounted () {
        console.log("guazai",this.$refs)
      },
      methods: {
        init (id, parentId, parentName, parentNodePath, orgType) {
          this.orgType = orgType
          this.dataForm.id = id || 0
          const ORG_TYPE_WORK = "WORK"
          const ORG_TYPE_PUR = "PUR"
          this.viewData.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            this.dataForm.tenantName = sessionStorage.getItem('tenantName')
            if (this.dataForm.id) {
              getOrgById(
                      {},this.dataForm.id
              ).then(data => {
                if (data && data.code === '00') {
                  console.log("data",data)
                  if(data.body.orgType === ORG_TYPE_WORK || data.body.orgType === ORG_TYPE_PUR){
                    console.log("jjjj",data.body.orgType)
                    this.viewData.forbidOrgTypeEdit = true
                  }else{
                    this.viewData.forbidOrgTypeEdit = false
                  }
                  this.dataForm.name = data.body.orgName
                  this.dataForm.code = data.body.orgCode
                  this.dataForm.parentId = data.body.parentId
                  this.dataForm.parentName = data.body.parentName
                  this.dataForm.orgTypeNew = data.body.orgType
         
                }
              })
            }else{
              this.dataForm.parentId = parentId ? parentId : 0
              this.dataForm.parentName = parentName ? parentName : '根节点'
              this.dataForm.parentNodePath = parentNodePath ? parentNodePath : ''
            }
          })
        },
        // 表单提交
        dataFormSubmit () {
          console.log("this.dataForm.orgTypeNew",this.dataForm.orgTypeNew)
          console.log("this.orgType",this.orgType)
,
          this.$refs['dataForm'].validate((valid) => {
            //校验
            if(this.dataForm.orgTypeNew == 'DIV'){
              if(this.orgType != "ROOT"){
                return this.$message.error("事业部的上一级组织必须为总部")
              }
            }
            if(this.dataForm.orgTypeNew == 'COM'){
              if(this.orgType != "DIV"){
                return this.$message.error("子公司的上一级组织必须为事业部")
              }
            }
            if(this.dataForm.orgTypeNew == 'PUR'){
              if(this.orgType != "COM"){
                return this.$message.error("采购组织的上一级组织必须为子公司")
              }
            }
            if(this.dataForm.orgTypeNew == 'WORK'){
              if(this.orgType != "PUR"){
                return this.$message.error("工厂的上一级组织必须为采购组织")
              }
            }

            if (valid) {
              let params = {
                'id': this.dataForm.id || undefined,
                'orgName': this.dataForm.name,
                'orgCode': this.dataForm.code,
                'parentId': this.dataForm.parentId,
                'parentName': this.dataForm.parentName,
                'parentNodePath': this.dataForm.parentNodePath,
                'orgType': this.dataForm.orgTypeNew
              }

              if(this.dataForm.id){
                editOrg(params).then(data => {
                  if (data && data.code === '00') {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      onClose: () => {
                        this.viewData.visible = false
                        this.$emit('refreshDataList')
                      }
                    })
                  } else {
                    this.$message.error(data.msg)
                  }
                })
              }else{
                createOrg(params).then(data => {
                  if (data && data.code === '00') {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      onClose: () => {
                        this.viewData.visible = false
                        this.$emit('refreshDataList')
                      }
                    })
                  } else {
                    this.$message.error(data.msg)
                  }
                })
              }
            }
          })
        }
      }
    }
  </script>
  
  
  <style lang="scss">
    .el-dialog__body{
      .org-dialog-form{
        width: 95%;
      }
    }
  </style>